"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = injectContent;

var _withContent = _interopRequireDefault(require("./withContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function injectContent(contentIds, contentAreaIds) {
  return function (InnerComponent) {
    return (0, _withContent.default)(InnerComponent, contentIds, contentAreaIds);
  };
}
//# sourceMappingURL=injectContent.js.map